import { render, staticRenderFns } from "./KomoditiView.vue?vue&type=template&id=862d51c6&scoped=true"
import script from "./KomoditiView.vue?vue&type=script&lang=js"
export * from "./KomoditiView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862d51c6",
  null
  
)

export default component.exports